import React from "react";
import { Label } from "../fields/Fields";

export type CheckBoxGroupProps = {
  children: React.ReactNode;
  className?: string;
  color?: "blue" | "green" | "red" | "yellow" | "indigo";
  size?: "sm" | "md" | "lg";
  value?: { value: any; setValue: any; onChange: any };
  vertical?: boolean;
  name: string;
  isTiny?: boolean;
  checkBoxItem: CheckBoxItem[];
  boxClassName?: string;
  titleClassName?: string;
  [key: string]: any;
  setState?: React.Dispatch<React.SetStateAction<CheckBoxItem[]>>;
};

export type CheckBoxItem = {
  id: string;
  title: React.ReactNode;
  value: boolean;
  disabled?: boolean;
};
const style = {
  sizes: {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  },
  colors: {
    blue: "text-blue-600 focus:ring-blue-500",
    green: "text-green-600 focus:ring-green-500",
    red: "text-red-600 focus:ring-red-500",
    yellow: "text-yellow-500 focus:ring-yellow-400",
    indigo: "text-indigo-600 focus:ring-indigo-500",
  },
  vertical: "flex flex-wrap",
};

export const CheckBoxGroup = ({
  children,
  className,
  color = "indigo",
  size = "md",
  value,
  vertical = false,
  isTiny = false,
  name,
  label,
  type,
  checkBoxItem,
  setState = value?.setValue(),
  boxClassName = "",
  titleClassName = "",
  ...props
}: CheckBoxGroupProps) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    const newItems = checkBoxItem.map((item) => {
      const newState = {...item};
      if(newState.id === event.target.id){
        newState.value = event.target.checked;
      }
      return newState;
    });
    setState(newItems);
  };

  return (
    <div className={`${vertical ? style.vertical : ""}`}>
      <Label
        className="mb-1 block text-sm font-medium text-gray-700"
        id={`check-box-group-${name}`}
      >{label}</Label>
      <div className={`${vertical ? style.vertical : ""} w-full ${className}`}>
        {checkBoxItem.map((item) => (
          <div key={item.id} className={`flex ${isTiny ? 'p-1' : 'p-2'} items-center`}>
            <input
              id={item.id}
              name={item.title?.toString()}
              type="checkbox"
              {...props}
              onChange={onChange}
              checked={item.value}
              className={`
                ${style.sizes[size]}
                ${isTiny ? '' : 'mr-1'}
                ${style.colors[color]}
                ${item.disabled ? "border-gray-100 checked:bg-gray-100 hover:checked:bg-gray-100" : "border-gray-300"}
                ${boxClassName}
              `}
              disabled={item.disabled}
            />
            <label
              htmlFor={item.id}
              className={`${isTiny ? '' : 'ml-1'} block text-sm font-medium ${item.disabled ? "text-gray-300" : "text-gray-900"} ${titleClassName}`}
            >
              {item.title}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
